import {Brick, registerBrick} from 'olympe';

export default class GenerateAPIKey extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {number} numberOfCharacters
     * @param {function()} forwardEvent
     * @param {function(string)} setAPIKey
     */
    update($, [numberOfCharacters], [forwardEvent, setAPIKey]) {
        const characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz+*%&/()=?!$';

        const key = Array.from(crypto.getRandomValues(new Uint32Array(numberOfCharacters)))
            .map((x) => characters[x % characters.length])
            .join('');

        setAPIKey(key);
        forwardEvent();
    }
}

registerBrick('018f870828355f4c7bd4', GenerateAPIKey);
